import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheck1 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 1.49902,
			width: 19,
			height: 19.001,
			rx: 9.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.5,
			y: 1.49902,
			width: 19,
			height: 19.001,
			rx: 9.5,
			stroke: "#191919",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.5566 7.72551C15.9471 8.11603 15.9471 8.7492 15.5566 9.13972L10.4239 14.2724C10.0334 14.6629 9.40026 14.6629 9.00973 14.2724L6.44341 11.706C6.05288 11.3155 6.05288 10.6824 6.44341 10.2918C6.83393 9.90131 7.4671 9.90131 7.85762 10.2918L9.71684 12.1511L14.1424 7.72551C14.5329 7.33499 15.1661 7.33499 15.5566 7.72551Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgCheck1);
export default ForwardRef;
